<template>
    <footer class="has-background-primary p-4">
        <p class="label has-text-white">Made for CruzHacks 2022</p>
    </footer>
</template>

<style>
    footer {
        margin-top: auto;
    }
</style>
